// extracted by mini-css-extract-plugin
module.exports = {"logo":"Logo_logo__2Pz-g","logoTitle":"Logo_logoTitle__1rlNR","logoImg":"Logo_logoImg__50bqO","logoImage":"Logo_logoImage__le1bh"};